// src/utils/api.js – Single Axios client used everywhere
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

const client = axios.create({ baseURL: BASE_URL });

client.interceptors.request.use(cfg => {
  const token = localStorage.getItem('codrion_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

client.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('codrion_token');
      window.location.href = '/auth';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register : (u,e,p) => client.post('/auth/register', { username:u, email:e, password:p }),
  login    : (e,p)   => client.post('/auth/login',    { email:e, password:p }),
  logout   : ()      => client.post('/auth/logout'),
  me       : ()      => client.get('/auth/me'),
  daily    : ()      => client.post('/auth/daily-reward'),
};

export const missionsAPI = {
  getAll : track  => client.get('/missions', { params: track ? { track } : {} }),
  getOne : id     => client.get(`/missions/${id}`),
  submit : (id,c) => client.post(`/missions/${id}/submit`, { code: c }),
  create : data   => client.post('/missions', data),
  update : (id,d) => client.put(`/missions/${id}`, d),
};

export const leaderboardAPI = {
  getTop10: () => client.get('/leaderboard'),
};

export const shopAPI = {
  getItems: ()    => client.get('/shop'),
  buy     : id    => client.post('/shop/buy',   { itemId: id }),
  equip   : id    => client.post('/shop/equip', { itemId: id }),
};

export const usersAPI = {
  profile         : ()    => client.get('/users/profile'),
  worldPosition   : pos   => client.put('/users/world-position', pos),
};

export const adminAPI = {
  stats            : ()       => client.get('/admin/stats'),
  users            : ()       => client.get('/admin/users'),
  setRole          : (id, r)  => client.put(`/admin/users/${id}/role`, { role: r }),
  deactivateMission: id       => client.delete(`/admin/missions/${id}`),
};

export default client;
